import React from "react"
import { Box } from "@material-ui/core"
import { Page, PageSection, SearchBar } from "src/components"
import SuspenseWrapper from "src/components/layout/SuspenseWrapper"
import ExpenseDataTable from "./components/ExpenseDataTable"

const ExpensesPage = () => {
  const [addNewItem, setAddNewItem] = React.useState(false)

  return (
    <>
      <Page title="Expenses Page">
        <SearchBar
          name="Expense"
          addNewItem={() => setAddNewItem(true)}
          mb={3}
        />
        <PageSection>
          <Box sx={{ pt: 3 }}>
            <SuspenseWrapper>
              <ExpenseDataTable
                addNewItem={addNewItem}
                onAddItemClose={() => setAddNewItem(false)}
              />
            </SuspenseWrapper>
          </Box>
        </PageSection>
      </Page>
    </>
  )
}

ExpensesPage.propTypes = {}

export default ExpensesPage
